module.exports = __webpack_public_path__ + "static/media/728x90_0004_en.7872dc1d.jpg";